import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useLazyCancelJobQuery,
  useLazyGetJobByIdQuery,
  useLazyGetJobFormByIdQuery,
  useLazyGetJobsQuery,
  useLazyRateTechnicianQuery,
} from "../../../Store/Builder/jobs.api";
import showToast from "../../Hooks/toast";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import {
  setActiveJob,
  setJobForm,
  setList,
} from "../../../Store/Slice/jobsSlice";
import { useEffect } from "react";

// Просто заглушка чтобы на странице job-details не приходил весь лист
  const useGetJobs = (allList = true) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {activeJob} = useSelector((state) => state.rootReducer.jobsSlice);
  const [getJobs] = useLazyGetJobsQuery();
  const [getJobById] = useLazyGetJobByIdQuery();
  const [getJobFormById] = useLazyGetJobFormByIdQuery();
  const [rateTechnician] = useLazyRateTechnicianQuery();
  const [cancelJob] = useLazyCancelJobQuery();
  const { searchValue, activeStatus, currentPage } = useSelector((state) => state.rootReducer.jobsSlice);
  const activeJobId = activeJob?.id;
  const formatParams = () => {
    const statusParams = `&status=${activeStatus?.id}`;
    const searchParams = `&search=${searchValue}`;
    const paginationParams = `page=${currentPage}&perPage=20`;
    return `${paginationParams}${searchValue ? searchParams : ""}${
      activeStatus?.id !== "all" ? statusParams : ""
    }`;
  };

  const get = () => {
    const formattedParams = formatParams();
    dispatch(setLoader(true));
    getJobs(formattedParams)
      .unwrap()
      .then((res) => {
        dispatch(setList(res));
        dispatch(setLoader(false));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  const getById = (title) => {
    dispatch(setLoader(true));
    return getJobById(location?.pathname !== '/update-payment' ? title : activeJob?.title)
      .unwrap()
      .then((res) => {
        dispatch(setActiveJob(res?.data));
        dispatch(setLoader(false));
        if(location?.pathname === '/update-payment') {
          navigate(-1)
        }
        return res?.data;
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
        navigate("/jobs");
        return null;
      });
  };

  const getJobForm = (params) => {
    dispatch(setLoader(true));
    getJobFormById(params)
      .unwrap()
      .then((res) => {
        dispatch(setJobForm(res));
        dispatch(setLoader(false));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  const rate = (data) => {
    dispatch(setLoader(true));
    rateTechnician(data)
      .unwrap()
      .then(() => getById(activeJob?.title))
      .then((res) => {
        showToast("Success", "success");
        dispatch(setLoader(false));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  const cancel = (params) => {
    dispatch(setLoader(true));
    cancelJob(params)
      .unwrap()
      .then(() => getById(activeJob?.title))
      .then((res) => {
        showToast("Success", "success");
        dispatch(setLoader(false));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  useEffect(() => {
    if (activeJobId === null && location.pathname === '/jobs') {
      get();
    }
  }, [searchValue, activeStatus, currentPage]);

  return {
    get,
    getById,
    getJobForm,
    rate,
    cancel,
  };
};

export default useGetJobs;
